import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {ToastrService} from 'ngx-toastr';
import {ActivityService} from '@components/my-web-desk/my-web-desk-sidebar/sidebar-content/sidebar-content-activity-center/activity-service.service';
import {DateObj} from '@app/interfaces/DateObj';
import {FormControl, FormGroup} from '@angular/forms';
import { DatePipe } from '@angular/common';
import {NotificationService} from '@app/services/notification/notification.service';
import * as FileSaver from 'file-saver';
import {ProventumApiService} from '@app/services/proventum-api.service';
@Component({
    selector: 'app-sidebar-content-activity-center',
    templateUrl: './sidebar-content-activity-center.component.html',
    styleUrls: ['./sidebar-content-activity-center.component.css']
})
export class SidebarContentActivityCenterComponent implements OnInit {

    newActivity = false;
    commentText = '';
    disableButton:boolean = false;
    activities = [];
    date: DateObj;
    start:any;
    end:any;
    totalActivities=[];
    satnica:any;
    disableDateRangeButton:boolean = false;


    @Output() activitiesSent = new EventEmitter<any>();


    constructor(public taskService: TaskService,
                private toastrService: ToastrService,
                private activityService: ActivityService,
                private notifyService:NotificationService,
                private datePipe:DatePipe,
                private proventumApiService:ProventumApiService


                ) {
    }

    ngOnInit() {
        this.activityService.setActivities([]);
        const today = new Date();
        this.date = {
            year: (today.getFullYear()),
            month: (today.getMonth() + 1),
            day: (today.getDate())
        };

    }

    getActivitiesDataRange()
    {
        this.disableDateRangeButton= true;
        this.totalActivities = [];
        this.satnica = [];

        const start = this.datePipe.transform(this.start, 'yyyy-MM-dd');
        const end = this.datePipe.transform(this.end, 'yyyy-MM-dd');

        this.activityService.getActivitiesDataRange(start, end).subscribe(async (response) => {
          this.satnica = response.result
          this.disableDateRangeButton = false;
          this.exportExcel();


        }, error => {
             console.log(error);
        });

    }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  exportExcel() {
    if (this.satnica.length > 0) {
      import("xlsx").then(xlsx =>{
        const worksheet = xlsx.utils.json_to_sheet(this.satnica);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "Satnica");
      });
    }
  }
    getActivitiesFromChildHandler(event) {
        this.activities = event;
        this.activityService.setActivities(event);
    }

    // slanje satnice u Proventum
    async sendActivitiesToProventum() {

        this.disableButton=true;
        let valid: any = false;
        valid = await this.checkIfDatesAreValid();
        if (valid == true && this.activities.length > 0) {
            this.activityService.sendDailyActivitiesToProventumInstance().subscribe(response => {
                if (response['type'] === 'success') {
                    this.toastrService.success('Satnica je uspješno poslata.');
                    let response = this.activityService.setActivitiesInactive(JSON.stringify(this.activities.filter(x => x.id))).subscribe(result => {
                        if (result['type'] === 'success') {
                            // this.activityService.setActivities([]); //TODO zakomentarisano da im se ne micu dnevne aktivnosti jer ako se one posalju pa maknu i onda napravi neka nova aktivnost i posalje taj novi niz, funk na bekendu od propventuma ce da izbrise prethodno poslate aktivnosti i upisati samo poslednju dodatu
                            // this.activities = [];
                            // this.activityService.activitiesSent.next(true)
                        }
                    });

                }

            });
        }
    }

    checkIfDatesAreValid() {
        return new Promise((resolve, reject) => {
            try {
                this.activities.forEach((item, index) => {
                    if (index !== this.activities.length - 1) {
                        if ((item.dateTo !== this.activities[index + 1].dateFrom) || item.automatic_activity == true) {
                            this.toastrService.info('Molimo Vas pravilno popunite podatke.');
                            resolve(false);
                        }
                    }
                });
                resolve(true);
            } catch (e) {
                reject(e);
            }
        });
    }


}
